import AnnotationStatusTag from '../AnnotationStatusTag/AnnotationStatusTag'
import ProductClassTag from '../ProductClassTag/ProductClassTag'
import { isTabularMode, ObservationsBrowserMode, ProductType } from './types'

export const getTagDecorator = (productType: ProductType) =>
  ({
    anomaly: ProductClassTag,
    classification: ProductClassTag,
    segmentation: AnnotationStatusTag,
    classification_patch: AnnotationStatusTag,
  }[productType])

export const getLightweightParams = (
  mode: ObservationsBrowserMode,
  imageData: boolean
) => ({
  limit: isTabularMode(mode) ? 100 : undefined,
  mode:
    isTabularMode(mode) && !imageData ? ('no_image_data' as const) : undefined,
})
